import favicon from 'assets/img/themes/stratos/favicon.png';
import background from 'assets/img/themes/stratos/background.png';
import logo from 'assets/img/themes/stratos/logo.png';
import sidebarLogo from 'assets/img/themes/stratos/logo-sidebar.png';
import collapsed from 'assets/img/themes/stratos/logo-sidebar-collapsed.png';

export default {
  background: {
    src: background,
  },
  logo: {
    src: logo,
    height: '156px',
  },
  sidebar: {
    logo: sidebarLogo,
    collapsed: collapsed,
  },
  page: {
    title: 'StratosShare',
    favicon: favicon,
    support: 'StratosShare Support',
  },
  footer: {
    url: 'https://launchmobility.com',
    copyright: 'StratosShare Inc.',
    version: true,
  },
};
